import { useState, useCallback } from 'react'

import { useSpring, SpringValue } from 'react-spring'

interface Hooks {
  isHovered: boolean
  setHover: () => void
  resetHover: () => void
  underlineSpring: Record<string, SpringValue>
}

export function useHooks(defaultWithUnderline?: boolean): Hooks {
  const [isHovered, toggleHovered] = useState(false)

  const setHover = useCallback(() => {
    toggleHovered(true)
  }, [])

  const resetHover = useCallback(() => {
    toggleHovered(false)
  }, [])

  let defaultScale = 'scale(0, 1)'
  let activeScale = 'scale(1, 1)'
  if (defaultWithUnderline) {
    defaultScale = 'scale(1, 1)'
    activeScale = 'scale(0, 1)'
  }

  const underlineSpring = useSpring({
    from: { transform: defaultScale },
    to: {
      transform: isHovered ? activeScale : defaultScale,
    },
    config: {
      mass: 1,
      tension: 200,
      friction: 30,
    },
  })

  return {
    isHovered,
    setHover,
    resetHover,
    underlineSpring,
  }
}
